import { View, Text } from "react-native";
import DatePickerInput from "../../../components/DatePickerInput";
import { useFormContext, Controller } from "react-hook-form";
import moment, { Moment } from "moment";
import { FormData } from "../ActivityFormScreen";
import { formatToUtc } from "../../../utils/dateUtils";

export default function ActivityDatesFields({ slug, minDate }: { slug: string; minDate: string }) {
  const { control, watch } = useFormContext<FormData>();
  const startDate = watch("startDate");

  return (
    <View className="mx-6 mt-6 mb-8 justify-between">
      <Text className="text-large-tight font-700 text-ink-darkest">Dates of Activity</Text>

      <Text className="text-small-normal font-400 text-ink mt-2 mb-4">
        Select the start date and end date for the {slug === "golf-coach" ? "coaching activity" : "activity or service"}.
      </Text>
      <View className="flex flex-col md:flex-row gap-2 web:gap-4">
        <View className="flex-1">
          <Controller
            name="startDate"
            control={control}
            rules={{
              required: "Start date is required",
            }}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <DatePickerInput
                onChange={onChange}
                value={value}
                testID="start-date-picker-input"
                placeholder="Start Date"
                title="Start Date"
                description="Select the start date for the activity."
                validate={(date: Moment) => {
                  if (date.isAfter(moment())) {
                    return "Start date cannot be in the future";
                  }
                  if (date.isBefore(moment(minDate))) {
                    return `Start date must be on or after ${formatToUtc(minDate)}.`;
                  }
                }}
                onBlur={() => {}}
                error={error}
              />
            )}
          />
        </View>
        <View className="flex-1">
          <Controller
            name="endDate"
            control={control}
            rules={{
              required: "End date is required",
            }}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <DatePickerInput
                onChange={onChange}
                value={value}
                testID="end-date-picker-input"
                placeholder="End Date"
                title="End Date"
                description="Select the end date for the activity."
                validate={(date: Moment) => {
                  if (date.isAfter(moment()) || date.isBefore(moment(startDate))) {
                    return "Must be between Start Date and now";
                  }
                }}
                onBlur={() => {}}
                error={error}
              />
            )}
          />
        </View>
      </View>
    </View>
  );
}
